var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGallery = function SvgGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 3A3.612 3.612 0 0 0 3 6.6v10.8C3 19.379 4.621 21 6.6 21h10.8c1.979 0 3.6-1.621 3.6-3.6V6.6C21 4.621 19.379 3 17.4 3H6.6Zm0 1.8h10.8c1.013 0 1.8.787 1.8 1.8v5.444l-1.241-1.241a2.057 2.057 0 0 0-1.459-.598c-.53 0-1.06.199-1.459.598l-2.855 2.856a.438.438 0 0 1-.583.044l-1.614-1.197a2.293 2.293 0 0 0-2.932.178L4.8 14.824V6.6c0-1.013.787-1.8 1.8-1.8Zm10.086 7.277 2.514 2.514V17.4c0 1.013-.787 1.8-1.8 1.8H6.6c-.967 0-1.8-.89-1.8-1.897l3.495-3.313a.475.475 0 0 1 .622-.037l1.614 1.195c.89.66 2.145.567 2.928-.216l2.855-2.855c.117-.117.306-.066.372 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 7.932a1.368 1.368 0 1 1-2.736 0 1.368 1.368 0 0 1 2.736 0Z",
    fill: "currentColor"
  })));
};
export default SvgGallery;